import { NavigationActions } from "@/components/navigation/ducks/slice"
import {
  ADMIN_FETCH_CONSTITUENT_SUBSCRIPTIONS,
  adminReceiveConstituentSubscriptions,
  DOWNLOAD_EMAIL_DATA,
} from "@/components/privacy/admin/ducks/Actions"
import {
  apiAdminFetchConstituentSubscriptions,
  apiDownloadEmailData,
} from "@/components/privacy/admin/ducks/AJAX"

export default (store) => (next) => (action) => {
  const { dispatch } = store
  const receiveConstituentSubscriptions = (cb) => (response) => {
    dispatch(adminReceiveConstituentSubscriptions(response.subscriptions))
    if (cb) {
      cb()
    }
  }

  const fetchSubscriptionsError = (cb) => () => {
    dispatch(NavigationActions.setSnackbar("Failed to find subscriptions"))
    if (cb) {
      cb()
    }
  }

  switch (action.type) {
    case ADMIN_FETCH_CONSTITUENT_SUBSCRIPTIONS:
      apiAdminFetchConstituentSubscriptions(
        action.constituentId,
        receiveConstituentSubscriptions(action.success),
        fetchSubscriptionsError(),
      )
      return next(action)

    case DOWNLOAD_EMAIL_DATA:
      apiDownloadEmailData(action.success, action.error)
      return next(action)

    default:
      return next(action)
  }
}
